import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n this.modalTitleKey}}
  @closeModal={{@closeModal}}
  class="history-modal -max {{concat '--mode-' (dasherize this.viewMode)}}"
>
  <:body>
    <ConditionalLoadingSpinner @condition={{this.initialLoad}}>
      <Modal::History::Revision
        @model={{this.postRevision}}
        @previousCategory={{this.previousCategory}}
        @currentCategory={{this.currentCategory}}
        @displayInline={{this.displayInline}}
        @displaySideBySide={{this.displaySideBySide}}
        @displaySideBySideMarkdown={{this.displaySideBySideMarkdown}}
        @viewMode={{this.viewMode}}
      />
      <Modal::History::Revisions
        @model={{this.postRevision}}
        @hiddenClasses={{this.hiddenClasses}}
        @mobileView={{this.site.mobileView}}
        @userChanges={{this.user_changes}}
        @previousCategory={{this.previousCategory}}
        @currentCategory={{this.currentCategory}}
        @previousTagChanges={{this.previousTagChanges}}
        @currentTagChanges={{this.currentTagChanges}}
        @bodyDiffHTML={{this.bodyDiffHTML}}
        @bodyDiff={{this.bodyDiff}}
        @calculateBodyDiff={{this.calculateBodyDiff}}
        @titleDiff={{this.titleDiff}}
        @viewMode={{this.viewMode}}
      />
    </ConditionalLoadingSpinner>
  </:body>
  <:footer>
    {{#if @model.editPost}}
      <Modal::History::TopicFooter
        @model={{this.postRevision}}
        @loadFirstVersion={{this.loadFirstVersion}}
        @loadPreviousVersion={{this.loadPreviousVersion}}
        @loadNextVersion={{this.loadNextVersion}}
        @loadLastVersion={{this.loadLastVersion}}
        @displayEdit={{this.displayEdit}}
        @editPost={{this.editPost}}
        @editButtonLabel={{this.editButtonLabel}}
        @revertToVersion={{this.revertToVersion}}
        @hideVersion={{this.hideVersion}}
        @showVersion={{this.showVersion}}
        @permanentlyDeleteVersions={{this.permanentlyDeleteVersions}}
        @loading={{this.loading}}
        @canPermanentlyDelete={{this.siteSettings.can_permanently_delete}}
        @loadFirstDisabled={{this.loadFirstDisabled}}
        @loadPreviousDisabled={{this.loadPreviousDisabled}}
        @displayRevisions={{this.displayRevisions}}
        @revisionsText={{this.revisionsText}}
        @loadNextDisabled={{this.loadNextDisabled}}
        @loadLastDisabled={{this.loadLastDisabled}}
        @revertToRevisionText={{this.revertToRevisionText}}
        @isStaff={{this.currentUser.staff}}
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "G4O6A28e",
  "block": "[[[8,[39,0],[[16,0,[29,[\"history-modal -max \",[28,[37,1],[\"--mode-\",[28,[37,2],[[30,0,[\"viewMode\"]]],null]],null]]]]],[[\"@title\",\"@closeModal\"],[[28,[37,3],[[30,0,[\"modalTitleKey\"]]],null],[30,1]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[8,[39,4],null,[[\"@condition\"],[[30,0,[\"initialLoad\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],null,[[\"@model\",\"@previousCategory\",\"@currentCategory\",\"@displayInline\",\"@displaySideBySide\",\"@displaySideBySideMarkdown\",\"@viewMode\"],[[30,0,[\"postRevision\"]],[30,0,[\"previousCategory\"]],[30,0,[\"currentCategory\"]],[30,0,[\"displayInline\"]],[30,0,[\"displaySideBySide\"]],[30,0,[\"displaySideBySideMarkdown\"]],[30,0,[\"viewMode\"]]]],null],[1,\"\\n      \"],[8,[39,6],null,[[\"@model\",\"@hiddenClasses\",\"@mobileView\",\"@userChanges\",\"@previousCategory\",\"@currentCategory\",\"@previousTagChanges\",\"@currentTagChanges\",\"@bodyDiffHTML\",\"@bodyDiff\",\"@calculateBodyDiff\",\"@titleDiff\",\"@viewMode\"],[[30,0,[\"postRevision\"]],[30,0,[\"hiddenClasses\"]],[30,0,[\"site\",\"mobileView\"]],[30,0,[\"user_changes\"]],[30,0,[\"previousCategory\"]],[30,0,[\"currentCategory\"]],[30,0,[\"previousTagChanges\"]],[30,0,[\"currentTagChanges\"]],[30,0,[\"bodyDiffHTML\"]],[30,0,[\"bodyDiff\"]],[30,0,[\"calculateBodyDiff\"]],[30,0,[\"titleDiff\"]],[30,0,[\"viewMode\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]],[[[1,\"\\n\"],[41,[30,2,[\"editPost\"]],[[[1,\"      \"],[8,[39,8],null,[[\"@model\",\"@loadFirstVersion\",\"@loadPreviousVersion\",\"@loadNextVersion\",\"@loadLastVersion\",\"@displayEdit\",\"@editPost\",\"@editButtonLabel\",\"@revertToVersion\",\"@hideVersion\",\"@showVersion\",\"@permanentlyDeleteVersions\",\"@loading\",\"@canPermanentlyDelete\",\"@loadFirstDisabled\",\"@loadPreviousDisabled\",\"@displayRevisions\",\"@revisionsText\",\"@loadNextDisabled\",\"@loadLastDisabled\",\"@revertToRevisionText\",\"@isStaff\"],[[30,0,[\"postRevision\"]],[30,0,[\"loadFirstVersion\"]],[30,0,[\"loadPreviousVersion\"]],[30,0,[\"loadNextVersion\"]],[30,0,[\"loadLastVersion\"]],[30,0,[\"displayEdit\"]],[30,0,[\"editPost\"]],[30,0,[\"editButtonLabel\"]],[30,0,[\"revertToVersion\"]],[30,0,[\"hideVersion\"]],[30,0,[\"showVersion\"]],[30,0,[\"permanentlyDeleteVersions\"]],[30,0,[\"loading\"]],[30,0,[\"siteSettings\",\"can_permanently_delete\"]],[30,0,[\"loadFirstDisabled\"]],[30,0,[\"loadPreviousDisabled\"]],[30,0,[\"displayRevisions\"]],[30,0,[\"revisionsText\"]],[30,0,[\"loadNextDisabled\"]],[30,0,[\"loadLastDisabled\"]],[30,0,[\"revertToRevisionText\"]],[30,0,[\"currentUser\",\"staff\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"concat\",\"dasherize\",\"i18n\",\"conditional-loading-spinner\",\"modal/history/revision\",\"modal/history/revisions\",\"if\",\"modal/history/topic-footer\"]]",
  "moduleName": "discourse/components/modal/history.hbs",
  "isStrictMode": false
});